// removed by extract-text-webpack-plugin
module.exports = {"container":"_2F9qY-C","container__hidden":"_2X1h55w","myAccountWidget":"_46ucpdl"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Widgets/Widget/index.css
// module id = ./template/components/Widgets/Widget/index.css
// module chunks = client.sitechrome